import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';
import { MMKVStoreKeyMap } from './mmkvStoreKeyMap';

export const mmkvCropPreference = new MMKV({
  id: MMKVStoreKeyMap.cropPreferenceStore,
});

export const zustandCropPreference: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvCropPreference.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvCropPreference.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvCropPreference.delete(name);
  },
};
